export default __webpack_public_path__ + "static/girl-31cd678d45932dd0767f88c850fb2ee1.mp4";